<style lang="scss"></style>
<style lang="scss" scoped="scoped"></style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 14px;display: flex;justify-content: space-between;" :style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#1D1D24' : '#000466' }">
    <div style="background:rgba(18, 18, 18, 1);height: 100%;width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;" :style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#121212' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
      <div style="color: white;font-weight: bold;font-size: 16px;margin-bottom: 4px;">
        {{ $t('mujurukudan') }}
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <span style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 16px;">{{ $t('daichuli') }}:</span><span style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 16px;">{{ count }}</span>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_model_out_count',
  components: {},
  watch: {},
  data() {
    return {
      timer: null,
      count: 0
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    console.log('$attrs', this.$attrs);
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/web/mould/in/bill/page?pageNum=1&pageSize=10&&status=1', {
        params: {
          //orgId: this.$attrs.orgId,
        }
      });
      this.count = response.data.total;
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {}, 800);
    }
  }
};
</script>
